export default __webpack_public_path__ + "img/empty_perks-530bcc2fbaf15048588fd64ca792d003.png";